import React from "react";
import { REPAIRS } from "../mock/mock";
import { fmt } from "../lib/mallet";

export function Repairs() {
  return (
    <section id="repairs">
      <div className="wrap">
        <div className="sec-head">
          <h2>Repairs and rebuilds</h2>
          <p style={{ color: "#5F574C" }}>Bring your mallets to the shop in Wellington or ship them to us. Most repairs turn around in three to five days; during the season we do same-week.</p>
        </div>
        <div className="repair-list">
          {REPAIRS.map(r => (
            <div className="repair" key={r.name}>
              <h3>{r.name}</h3>
              <p>{r.text}</p>
              <div className="row">
                <span className="price">{fmt(r.price)}</span>
                <a className="btn btn-paper" href="#shop">Add from the shop</a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function Contact() {
  return (
    <section id="contact">
      <div className="wrap">
        <div className="contact-grid">
          <div>
            <h2>Talk to us before you order</h2>
            <p style={{ marginTop: "1rem" }}>Not sure on length or weight? Call or text and we'll size you over the phone. We're in Wellington, Florida, minutes from the polo fields.</p>
            <a className="big" href="tel:+16305367971">+1 (630) 536-7971</a>
            <a className="big" href="https://instagram.com/aubonepolomallets" target="_blank" rel="noopener noreferrer">@aubonepolomallets</a>
          </div>
          <div>
            <h3>Shop hours</h3>
            <p>Monday to Saturday, 9am–6pm during the season. Sunday by appointment.</p>
            <h3 style={{ marginTop: "1.5rem" }}>Shipping</h3>
            <p>We ship mallets anywhere in the US. Sets of 6 or more ship free. International by quote.</p>
          </div>
        </div>
        <footer className="wrap" style={{ marginTop: "3rem" }}>
          <span>Aubone Polo Mallets — Wellington, Florida</span>
          <span>Custom mallets, team sets and repairs</span>
        </footer>
      </div>
    </section>
  );
}
